'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _Set = require('@babel/runtime-corejs3/core-js-stable/set');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _sortInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/sort');
var CodeMirror = require('codemirror');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _Set__default = /*#__PURE__*/_interopDefaultLegacy(_Set);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _sortInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sortInstanceProperty);
var CodeMirror__namespace = /*#__PURE__*/_interopNamespace(CodeMirror);

var graphInfo = [];
var wordsInQuery = [];
function setGraphInfo(newInfo) {
  graphInfo = newInfo;
}
function setWordsInQuery(newWordsInQuery) {
  wordsInQuery = newWordsInQuery;
}

/**
 * Remove current unfinished word from auto suggestion.
 *
 * @param curWord
 */
function removeUnfinishedCurWord(curWord) {
  var countCurWord = _filterInstanceProperty__default["default"](wordsInQuery).call(wordsInQuery, function (word) {
    return word === curWord;
  }).length;
  // Remove curWord from auto suggestion list only when it does not exist in other place.
  if (countCurWord === 1) {
    wordsInQuery = _filterInstanceProperty__default["default"](wordsInQuery).call(wordsInQuery, function (word) {
      return word !== curWord;
    });
  }
}

/**
 * Retrieve the matched words from dictionary based on current input string.
 *
 * @export
 * @param {*} editor
 * @returns {{ list: string[]; from: CodeMirror.Position; to: CodeMirror.Position }}
 */
function getHint(editor, dictionary) {
  var _context;
  var cur = editor.getCursor(),
    curLine = editor.getLine(cur.line);
  var start = cur.ch,
    end = start;
  while (end < curLine.length && /[\w$]+/.test(curLine.charAt(end))) {
    ++end;
  }
  while (start && /[\w@$]+/.test(curLine.charAt(start - 1))) {
    --start;
  }
  var curWord = start !== end && _sliceInstanceProperty__default["default"](curLine).call(curLine, start, end);
  var regex = new RegExp('^' + curWord, 'i');
  removeUnfinishedCurWord(curWord);
  var allHints = _toConsumableArray__default["default"](new _Set__default["default"](_concatInstanceProperty__default["default"](dictionary).call(dictionary, graphInfo, wordsInQuery)));
  return {
    list: _sortInstanceProperty__default["default"](_context = !curWord ? [] : _filterInstanceProperty__default["default"](allHints).call(allHints, function (item) {
      return item.match(regex);
    })).call(_context),
    from: CodeMirror__namespace.Pos(cur.line, start),
    to: CodeMirror__namespace.Pos(cur.line, end)
  };
}

exports.getHint = getHint;
exports.setGraphInfo = setGraphInfo;
exports.setWordsInQuery = setWordsInQuery;
